import { useState } from "react";
import styled from "styled-components";
import { blueColor } from "../../../../styled/Theme";
import PrivacyPolicy from "./PrivacyPolicy";
import TermsAndConditions from "./TermsAndConditions";

const tabs = [
  { key: "privacy", label: "Privacy Policy" },
  { key: "terms", label: "Terms & Conditions" },
];

export default function LegalOverview() {
  const [activeTab, setActiveTab] = useState("privacy");

  return (
    <Wrapper>
      <Container>
        <Header>
          <h1>Legal & Policy Centre</h1>
          <p>
            Review our policies governing privacy, data protection, and use of
            OnePayX services.
          </p>
        </Header>

        <TabsBar>
          {tabs.map((tab) => (
            <TabButton
              key={tab.key}
              active={activeTab === tab.key}
              onClick={() => setActiveTab(tab.key)}
            >
              {tab.label}
            </TabButton>
          ))}
        </TabsBar>

        <TabContent>
          {activeTab === "privacy" && <PrivacyPolicy />}
          {activeTab === "terms" && <TermsAndConditions />}
        </TabContent>
      </Container>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  background: #f8fafc;
  padding: 80px 20px;
`;

const Container = styled.div`
  //   max-width: 1100px;
  margin: 0 auto;
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 40px;

  h1 {
    font-size: 2.4rem;
    color: ${blueColor};
    margin-bottom: 10px;
  }

  p {
    color: #64748b;
    font-size: 1rem;
    margin: 0 auto;
  }
`;

const TabsBar = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-bottom: 40px;
  flex-wrap: wrap;
`;

const TabButton = styled.button<{ active?: boolean }>`
  padding: 12px 22px;
  border-radius: 30px;
  border: 1px solid ${({ active }) => (active ? blueColor : "#e2e8f0")};
  background: ${({ active }) => (active ? blueColor : "#ffffff")};
  color: ${({ active }) => (active ? "#ffffff" : "#334155")};
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.25s ease;

  &:hover {
    background: ${({ active }) => (active ? blueColor : "#f1f5f9")};
  }
`;

const TabContent = styled.div`
  background: #ffffff;
  border-radius: 20px;
  //   box-shadow: 0 12px 30px rgba(0, 0, 0, 0.08);

  @media (max-width: 768px) {
    padding: 30px 20px;
  }
`;
